import memberAccountService from '../services/memberAccountService';

const handleResponse = (result, fallbackMessage) => {
  if (!result?.success) {
    const error = new Error(result?.message || fallbackMessage);
    error.details = result;
    throw error;
  }
  return result;
};

export const fetchMemberAccountSummary = async (params) => {
  const result = await memberAccountService.getMemberAccountSummary(params);
  return handleResponse(result, 'Üye hesap özeti alınamadı').data;
};

export const fetchMemberAccountLedger = async (params) => {
  const result = await memberAccountService.getMemberAccountLedger(params);
  const handled = handleResponse(result, 'Hesap defteri alınamadı');
  return { data: handled.data || [], meta: handled.metaData };
};

export default {
  fetchMemberAccountSummary,
  fetchMemberAccountLedger,
};
